import { SyntheticEvent } from 'react'
import { noop } from 'lodash'

export function createEvent<T extends SyntheticEvent = SyntheticEvent>(
  props: Partial<T['target']>
): T {
  return {
    preventDefault: noop,
    target: { ...props },
  } as T
}
